import find from 'lodash-es/find';

export default {
    methods: {
        getSalesCustomMapMarkerIcon(marker) {
            const addresses = this.getMduAddresses(marker);

            // If any MDU address is unsigned => show a neutral MDU icon
            if (addresses.length > 1) {
                if (find(addresses, address => address.is_signed === false)) {
                    return '/img/map/mdu-neutral.png';
                }

                return '/img/map/mdu-signed.png';
            }

            return null;
        },
        getDeliveryAddressIcon(marker, isInProject) {
            // If they belong to another delivery project, they can't be included in
            // this delivery project so they are disabled.

            const suffix = marker.delivery_project_id && ! isInProject ? '-disabled' : '';
            const addressList = isInProject ? this.addressesBelongingToDeliveryProject : this.addresses;
            const mduIcon = this.getDeliveryMduMarkerIcon(marker, isInProject, addressList);

            if (mduIcon) {
                return mduIcon;
            }

            let scaledSize = {
                width: 51,
                height: 34.5,
            };

            if (! marker.is_signed && ! marker.delivery_project_id) {
                return {
                    url: `/img/map/delivery/unsigned${suffix}.png`,
                    scaledSize: {
                        width: 24,
                        height: 24,
                    },
                };
            }

            if (! marker.is_signed && marker.delivery_project_id) {
                return {
                    url: `/img/map/delivery/unsigned-delivery${suffix}.png`,
                    scaledSize: {
                        width: 24,
                        height: 24,
                    },
                };
            }

            if (! marker.delivery_project_id) {
                let url = '/img/map/neutral.png';
                if (marker.is_signed) {
                    url = '/img/map/delivery/signed.png';
                }

                return {
                    url,
                    scaledSize: {
                        width: 24,
                        height: 24,
                    },
                };
            }

            let iconFileName = marker.finished_statuses.length ? marker.finished_statuses.join('-') : 'none';
            scaledSize = {
                width: (102 * 0.7), // 102 original size
                height: (53 * 0.7), // 53 original size
            };

            if (marker.finished_statuses.includes('activated')) {
                iconFileName = 'activated';
                scaledSize = {
                    width: (51 * 0.7), // 51 original size
                    height: (59 * 0.7), // 59 original size
                };
            }

            return {
                url: `/img/map/field/delivery/${iconFileName}.png`,
                scaledSize,
            };
        },
        getDeliveryMduMarkerIcon(selectedAddress, isInProject, addressesList) {
            const suffix = ! isInProject ? '-disabled' : '';

            const addresses = this.getMduAddresses(selectedAddress, addressesList);

            if (addresses.length > 1) {
                return {
                    url: `/img/map/delivery/mdu-unsigned${suffix}.png`,
                    scaledSize: { width: 56, height: 62 },
                };
            }

            return null;
        },
        getMduAddresses(selectedAddress, addresses = null) {
            const addressesList = Object.values(addresses || this.addresses);

            return addressesList.filter(address => {
                return address.full_address === selectedAddress.full_address;
            });
        },
        markerPosition(marker) {
            return {
                lat: parseFloat(marker.lat),
                lng: parseFloat(marker.lng),
            };
        },
    },
};
